import { render, staticRenderFns } from "./menuSurat.vue?vue&type=template&id=7e34083f&"
import script from "./menuSurat.vue?vue&type=script&lang=js&"
export * from "./menuSurat.vue?vue&type=script&lang=js&"
import style0 from "./menuSurat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QAvatar,QBtn,QSeparator,QImg,QDialog,QCard,QCardSection,QInput,QMarkupTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QAvatar,QBtn,QSeparator,QImg,QDialog,QCard,QCardSection,QInput,QMarkupTable})
